import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router'

import { DashboardPageComponent } from '../dashboard/dashboard-page/dashboard-page.component';

const routes: Routes = [
  { path: '', component: DashboardPageComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
